import * as React from "react";

export const CollapseIcon = props => (
  <svg {...props} fill="#000000" height="24" viewBox="0 0 24 24" width="24">
    <path d="M19 13H5v-2h14v2z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
);
